import { JSX } from 'react';
import { GamificationIconType } from '@bg-components/GamificationIcon/enums';
import { GamificationIcon } from '@bg-components/GamificationIcon/GamificationIcon';
import { IGamificationIcon } from '@bg-components/GamificationIcon/interfaces';

export const GamificationExclamation = (props: IGamificationIcon): JSX.Element => (
    <GamificationIcon className={props.className} icon={GamificationIconType.EXCLAMATION} />
);
